import React, { useEffect } from 'react';
import { Form, Grid } from '@arco-design/web-react';
import { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { LoginFormField } from './LoginFormField';
import {
  handleApiError,
  removeLeadingSpace,
  removeSpaces,
  sanitizeEmail,
  setLocalStorage,
} from '../../../common/Utils/Utils';
import { ManageApis } from '../../../common/APIS/ManageApis';
import InputField from '../../InputField/InputField';
import { useAlert } from '../../../common/Context/AlertContext';
import { useAuth } from '../../../common/Context/AuthContext';
import SubmitButton from '../../submitButton/SubmitButton';
import { useStoreValues } from '../../../common/Context/GlobalContext/GlobalStateProvider';
import notify from '../../../common/Utils/toastService';
import {
  HARDCODED_PRODUCTKEY,
  PRODUCT_PLATFORM,
} from '../../../common/constant';

function LoginForm() {
  const { showAlert } = useAlert();
  const { login } = useAuth();
  const { fetchCreditDetails } = useStoreValues();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleInputChange = (value, field) => {
    const valueWithoutLeadingSpace = removeLeadingSpace(value);
    if (field === 'email') {
      const sanitizedEmailValue = sanitizeEmail(valueWithoutLeadingSpace);
      form.setFieldValue(field, sanitizedEmailValue);
    } else if (field === 'password') {
      const sanitizedPassword = removeSpaces(value);
      form.setFieldValue(field, sanitizedPassword);
    } else {
      form.setFieldValue(field, value);
    }
  };

  const handleSubmit = async (accountReferenceId) => {
    try {
      const isValid = await form.validate();
      if (!isValid) {
        console.log('Validation failed. Please check the form.');
        return;
      }
      const dataGet = form.getFieldsValue();
      const reqBody = {
        ...dataGet,
        productKey: HARDCODED_PRODUCTKEY,
        account:
          typeof accountReferenceId == 'string' ? accountReferenceId : '',
        platform: PRODUCT_PLATFORM.PCS_PLATFORM,
      };

      setIsSubmitting(true);
      const response = await ManageApis('post', window.login, reqBody, '');
      const { message: responseMessage, status_code } = response || {};
      const {
        token,
        role,
        name,
        userId,
        status,
        onBoardingStage,
        message,
        subscribedProducts,
        accountId,
        credits,
        accountDetails,
      } = response?.response_data || {};
      if (status_code !== 200 || responseMessage !== 'Success') {
        handleApiError(status, responseMessage, status_code, showAlert);
        return;
      }
      if (status_code == 200 && responseMessage == 'Success') {
        if (status === 'Success') {
          const userData = {
            token,
            name,
            id: userId,
            credits,
            accountId,
          };
          login(userData);
          setLocalStorage('token', token);
          setLocalStorage('name', name);
          setLocalStorage('id', userId);
          setLocalStorage('accountid', accountId);
          const searchParams = new URLSearchParams(window.location.search);
          const redirectProduct = searchParams.get('redirectProduct');
          setLocalStorage('redirectProduct', redirectProduct);
          const redirectCategory = searchParams.get('category');
          setLocalStorage('category', redirectCategory);

          // Message.success(message);
        } else if (status == 'Failed') {
          if (onBoardingStage === 1) {
            notify.success(message);
            navigate(`/verify-email`, { state: { emailId: dataGet?.email } });
          } else {
            notify.error(message);
          }
        }
      } else {
        handleApiError(status, message, status_code, showAlert);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="w-100 position-relative ">
        <div className="p-md-0 ms-lg-4">
          <h3 className="font_30 fw_600">Login</h3>
          <p className="font_12 font_500 text_gray10 mb-3">
            Access your account and manage your services effortlessly.
          </p>
          <div className="customForm">
            <Form
              form={form}
              ref={formRef}
              autoComplete="off"
              // onSubmit={handleSubmit}
            >
              <Form.Item>
                <div className="customInput">
                  <Grid.Row style={{ alignItems: 'center' }} gutter={12}>
                    {LoginFormField(form).map((field) => (
                      <InputField
                        inputStyle={{ height: '42px' }}
                        key={field.field}
                        value={form.getFieldValue(field.field)}
                        onChange={(value) =>
                          handleInputChange(value, field.field)
                        } // Use custom onChange handler
                        {...field}
                      />
                    ))}
                  </Grid.Row>
                </div>
                <div className="d-flex justify-content-end">
                  <div className="text_gray10">
                    Forgot Password ?{' '}
                    <Link
                      to={`/forgot-password`}
                      className="text-primary cursor-pointer"
                    >
                      Click here
                    </Link>
                  </div>
                </div>
                <div className="position-relative">
                  <div className="d-flex justify-content-between align-items-center">
                    <SubmitButton
                      onClick={handleSubmit}
                      isLoading={isSubmitting}
                      className="mt-2 rounded-pill"
                      label="Login"
                    />
                  </div>
                  <div className="mt-2 pt-2 d-flex justify-content-between">
                    <div className="text_gray10  ">
                      Don't have an account?{' '}
                      <Link to={`/register`} href="">
                        Register
                      </Link>
                    </div>
                  </div>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginForm;
